var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-control",style:({ maxWidth: _vm.size * 4.31 + 'px' })},[_c('div',{staticClass:"count-plus",style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      backgroundSize: _vm.size / 2 + 'px',
    }),on:{"click":function($event){return _vm.$emit('plus')}}}),_vm._v(" "),_c('div',{staticClass:"count",style:({ fontSize: 0.65 * _vm.size + 'px' })},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"count-minus",style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      backgroundSize: _vm.size / 2 + 'px',
      minWidth: 0.9 * _vm.size + 'px',
    }),on:{"click":function($event){return _vm.$emit('minus')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }